import React, { useState, useEffect } from 'react'
import TopBar from '../../Components/Auditor/TopBar'
import SideBar from '../../Components/Auditor/SideBar'
import Main from '../../Components/Auditor/Main'

const AuditorDashboard = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const [activeScreen, setActiveScreen] = useState('dashboard')
  const [screenParams, setScreenParams] = useState(null)

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle)
  }

  useEffect(() => {
    // Toggle the class on body element based on sidebarToggle state
    if (sidebarToggle) {
      document.body.classList.add('toggle-sidebar')
    } else {
      document.body.classList.remove('toggle-sidebar')
    }
  }, [sidebarToggle])

  // Handle navigation events from child components
  useEffect(() => {
    const handleNavigate = (event) => {
      const { screen, params } = event.detail
      if (screen) {
        setActiveScreen(screen)
        setScreenParams(params || null)
      }
    }

    window.addEventListener('navigateToScreen', handleNavigate)
    return () => {
      window.removeEventListener('navigateToScreen', handleNavigate)
    }
  }, [])

  useEffect(() => {
    const screensRequiringParams = ['stock-movement-history-detail']
    if (!screensRequiringParams.includes(activeScreen)) {
      setScreenParams(null)
    }
  }, [activeScreen])

  return (
    <>
      <TopBar onToggleSidebar={handleSidebarToggle} setActiveScreen={setActiveScreen}/>
      <SideBar activeScreen={activeScreen} setActiveScreen={setActiveScreen}/>
      <Main activeScreen={activeScreen} screenParams={screenParams}/>
    </>
  )
}

export default AuditorDashboard